document.addEventListener('DOMContentLoaded', () => {
  const progress = document.querySelector('.article-progress');
  const article = document.querySelector('.article-template');

  if (!progress || !article) return;

  const updateProgress = () => {
    const articleTop = article.offsetTop;
    const articleHeight = article.offsetHeight;
    const viewportBottom = window.scrollY + window.innerHeight;
    const percentage = ((viewportBottom - articleTop) / articleHeight) * 100;

    progress.style.width = `${Math.max(0, Math.min(percentage, 100))}%`;
  };

  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
});
